import React from "react";
import { StarTwoTone } from "@ant-design/icons";
import { Flex } from "antd";
import { useTranslation } from "react-i18next";

import { COLORS, STAR_PRIORITY } from "../../utils/Util";
import { ItemAttributes } from "../../../types/model";

interface ItemInfoProps {
  item: ItemAttributes;
  qty: number;
  qtyColor?: string;
  priority?: number | string;
  selectedQty?: number;
}

const ItemInfo: React.FC<ItemInfoProps> = ({ item, qty, qtyColor, priority, selectedQty }) => {
  const { t } = useTranslation();

  return (
    <Flex style={{ fontSize: 18 }}>
      <div
        style={{
          marginRight: 8,
          color: qtyColor ? qtyColor : COLORS[qty % COLORS.length],
        }}
      >
        {qty}
      </div>
      <div style={{ flex: 1 }}>
        <span>{item.alternate_name ? item.alternate_name : item.name}</span>
        {priority === STAR_PRIORITY && (
          <StarTwoTone style={{ fontSize: 20, margin: "0px 8px" }} twoToneColor="#ffc300" />
        )}
        <div>
          {item.modifications && <div>{item.modifications.join(", ")}</div>}
          {item.notes && <div>{item.notes}</div>}
        </div>
        {selectedQty && (
          <div>
            {t("selected")}:{" "}
            <span style={{ color: COLORS[selectedQty % COLORS.length] }}>{selectedQty}</span>
          </div>
        )}
      </div>
    </Flex>
  );
};

export default ItemInfo;
